import React from "react"
import { Player, ControlBar } from "video-react"

const VideoPlayer = props => {
  return (
    <Player
      autoPlay
      loop="true"
      width="auto"
      height="auto"
      src={props.data}
      muted={true}
    >
      <ControlBar disableCompletely={true} className="my-class" />
    </Player>
  )
}

export default VideoPlayer
